import { combineReducers } from 'redux';
import paintReducer from './paintReducer';

const rootReducer = combineReducers({
  paintReducer,
  // Future planning
  //...
});

export default rootReducer;
